"use client";

import _slicedToArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useComboboxContext } from "./VEVQD5MH.js";
import { useSelectContext } from "./KPEX55MY.js";
import { useCompositeStoreProps } from "./4CMBR7SL.js";
import { useStore, useStoreProps } from "./YV4JVR4I.js";
import { useUpdateEffect } from "./ABQUS43J.js";
import { __spreadProps, __spreadValues } from "./3YLGPPWQ.js";

// src/tab/tab-store.ts
import * as Core from "@ariakit/core/tab/tab-store";
import { useMemo } from "react";
function useTabStoreProps(store, update, props) {
  useUpdateEffect(update, [props.composite, props.combobox]);
  store = useCompositeStoreProps(store, update, props);
  useStoreProps(store, props, "selectedId", "setSelectedId");
  useStoreProps(store, props, "selectOnMove");
  var _useStore = useStore(function () {
      return store.panels;
    }, {}),
    _useStore2 = _slicedToArray(_useStore, 2),
    panels = _useStore2[0],
    updatePanels = _useStore2[1];
  useUpdateEffect(updatePanels, [store, updatePanels]);
  return Object.assign(useMemo(function () {
    return __spreadProps(__spreadValues({}, store), {
      panels: panels
    });
  }, [store, panels]), {
    composite: props.composite,
    combobox: props.combobox
  });
}
function useTabStore() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var combobox = useComboboxContext();
  var composite = useSelectContext() || combobox;
  props = __spreadProps(__spreadValues({}, props), {
    composite: props.composite !== void 0 ? props.composite : composite,
    combobox: props.combobox !== void 0 ? props.combobox : combobox
  });
  var _useStore3 = useStore(Core.createTabStore, props),
    _useStore4 = _slicedToArray(_useStore3, 2),
    store = _useStore4[0],
    update = _useStore4[1];
  return useTabStoreProps(store, update, props);
}
export { useTabStoreProps, useTabStore };